import { useScopedTranslate } from '@locale/translate';

const translations = {
  en: {
    placeholder: 'Upload file',
    accepted: 'Accepted file types:',
    maxFileSize: 'Max file size: {size} MB',
    tooLarge: 'Over the {limit} MB limit – not uploaded',
    remove: 'Remove file',
  },
  is: {
    placeholder: 'Bæta við skrá',
    accepted: 'Leyfðar skráartegundir:',
    maxFileSize: 'Hámarksstærð skráar: {size} MB',
    tooLarge: 'Yfir {limit} MB hámarkinu – ekki hlaðið upp',
    remove: 'Fjarlægja skrá',
  },
  dk: {
    placeholder: 'Vælg fil',
    accepted: 'Accepterede filtyper:',
    maxFileSize: 'Maks. filstørrelse: {size} MB',
    tooLarge: 'Over grænsen på {limit} MB – ikke uploadet',
    remove: 'Fjern fil',
  },
};

export const useFileTranslations = () => useScopedTranslate(translations);
